<script lang="ts">
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
  } from "$lib/components/ui/dialog";
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import { Button } from "$lib/components/ui/button";

  import { overlay } from "$lib/stores/ui"
  import { t } from "$lib/i18n";
  import { user } from "$lib/stores/auth";

  const loginOpen = overlay('login');

  let email = $state("");
  let password = $state("");

  $effect(() => {
    if ($loginOpen) {
      email = "";
      password = "";
    }
  });

  interface Props {
    onLogin: (data: { email: string; password: string }) => Promise<boolean>;
  }

  let { onLogin }: Props = $props();

  async function handleSubmit() {
    const success = await onLogin({ email, password });
    console.log(`Login success: ${success ? "TRUE" : "FALSE"}`);
    if (success) {
      loginOpen.set(false);
    }
    else {
      loginOpen.set(true);
    }
  }
</script>

<Dialog bind:open={$loginOpen}>
  <DialogContent
    escapeKeydownBehavior={$user ? 'close' : 'ignore'}
    interactOutsideBehavior={$user ? 'close' : 'ignore'}
    class="hide-close-button"
  >
    <DialogHeader>
      <DialogTitle>{$t('login.title')}</DialogTitle>
      <DialogDescription>
        {$t('login.description')}
      </DialogDescription>
    </DialogHeader>

    <div class="grid gap-4 py-4">
      <div class="grid grid-cols-4 items-center gap-4">
        <Label for="email" class="text-right">{$t('login.email')}</Label>
        <Input
          id="email"
          type="email"
          bind:value={email}
          class="col-span-3"
        />
      </div>

      <div class="grid grid-cols-4 items-center gap-4">
        <Label for="password" class="text-right">{$t('login.password')}</Label>
        <Input
          id="password"
          type="password"
          bind:value={password}
          class="col-span-3"
        />
      </div>
    </div>
    <form onsubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
    <DialogFooter>
      {#if $user}
        <Button type="button" variant="outline" onclick={() => loginOpen.set(false)}>
          {$t('login.cancel')}
        </Button>
      {/if}
      <Button type="submit">
        {$t('login.button')}
      </Button>
    </DialogFooter>
    </form>
  </DialogContent>
</Dialog>
